// extracted by mini-css-extract-plugin
module.exports = {"Container":"Signature-module--Container--1gKYB","Item":"Signature-module--Item--2ZF_k"};